module.exports = __webpack_public_path__ + "img/dafra.28e89c44.jpg";